/**!
 * Created by Leonardo Cheslacki on 22/02/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/**
 *
 * @type {{}}
 */
module.exports.main = {
    /**
     * Paths of src for compact min.
     */
    paths: [
        'index',
        'src/capa/capa',
        'src/diferenciais/diferenciais',
        'src/ficha/ficha',
        'src/imagens/imagens',
        'src/implantacoes/implantacao01/implantacao01',
        'src/implantacoes/implantacao02/implantacao02',
        'src/implantacoes/implantacao03/implantacao03',
		'src/implantacoes/implantacao04/implantacao04',
        'src/implantacoes/orientacao/orientacao',
        'src/localizacao/localizacao',
        'src/orientacao/orientacao',
        'src/plantas/planta01/planta01',
        'src/plantas/planta02/planta02',
        'src/plantas/planta03/planta03',
		'src/plantas/planta04/planta04',
		'src/plantas/planta05/planta05',
		'src/plantas/planta06/planta06',
		'src/plantas/planta07/planta07',
        'src/projetistas/projetistas',
        'src/vistas/vistas',
        'src/historia/historia'
    ]
};

/**
 *
 * @type {{}}
 */
module.exports.menu = {
    /**
     * name: {string} FLA file name;
     * frame: {int} Menu button number, Ex: Number 2 is the occurrence btn_page02,
     * you cannot use number 1 because it is reserved for the empty page "In adobe animate, the frame with the label frame01 is empty because of the bugs."
     * type: {string} Type of link 'video', 'tour', 'external', 'paginate' or 'audio';
     * uri: {string} URI or URL when use a 'type';
     * logo: {string} It's size of the logo 'none', 'small', 'medium' or 'large';
     * dynamic: {boolean} Layer "background_dynamic" synchronized with the button;
     * default: {string} Page default init;
     *
     * xml: For multi or only one gallery, add frame01Gallery in actions.
     *
     * Marker changes from 'frame';
     * Occurrence btn_page** execute the 'frame**' correspondent, Ex: 'btn_page02' for 'frame02';
     */
    index: [
        {
            name: 'capa',
            frame: 2,
            uri: null,
            type: null,
            logo: 'none',
            dynamic: true,
            default: true
        },
        {
            name: 'ficha',
            frame: 3,
            uri: null,
            type: null,
            logo: 'large',
            dynamic: true,
            default: false
        },
        {
            name: 'implantacoes',
            frame: 4,
            uri: null,
            type: 'paginate',
            logo: 'large',
            dynamic: true,
            default: false,
            paginates: [
                {
                    name: 'implantacao01',
                    frame: 1,
                    uri: null,
                    type: null,
                    xml: 'implantation01.xml',
                    content_text: {
                        frame_01: {
                            A: 17,
                            B: 25
                        }
                    },
                    default: true
                },
                {
                    name: 'implantacao02',
                    frame: 2,
                    uri: null,
                    type: null,
                    xml: 'implantation02.xml',
                    content_text: {
                        frame_01: {
                            A: 11,
                            B: 25
                        }
                    },
                    default: false
                },
                {
                    name: 'implantacao03',
                    frame: 3,
                    uri: null,
                    type: null,
                    xml: 'implantation03.xml',
                    content_text: {
                        frame_01: {
                            A: 11,
							B: 22
                        }
                    },
                    default: false
                },
                {
                    name: 'implantacao04',
                    frame: 4,
                    uri: null,
                    type: null,
                    xml: 'implantation04.xml',
                    content_text: {
                        frame_01: {
                            A: 11,
							B: 22
                        }
                    },
                    default: false
                }
            ]
        },
        {
            name: 'orientacao',
            frame: 5,
            uri: null,
            type: null,
            logo: 'large',
            dynamic: true,
            default: false
        },
        {
            name: 'localizacao',
            frame: 6,
            uri: null,
            type: null,
            logo: 'large',
            dynamic: true,
            default: false
        },
        {
            name: 'projetistas',
            frame: 7,
            uri: null,
            type: null,
            logo: 'large',
            dynamic: true,
            default: false
        },
        {
            name: 'diferenciais',
            frame: 8,
            uri: null,
            type: null,
            logo: 'large',
            dynamic: true,
            default: false
        },
        {
            name: 'imagens',
            frame: 9,
            uri: null,
            type: null,
            xml: 'gallery.xml',
            logo: 'large',
            dynamic: true,
            default: false
        },
        {
            name: 'plantas',
            frame: 10,
            uri: null,
            type: 'paginate',
            logo: 'large',
            dynamic: true,
            default: false,
            paginates: [
                {
                    name: 'planta01',
                    frame: 1,
                    uri: null,
                    type: null,
                    active: {
                        differential: true,
                        camera: true
                    },
                    default: true
                },
                {
                    name: 'planta02',
                    frame: 2,
                    uri: null,
                    type: null,
                    active: {
                        differential: true,
                        pin: true,
                        camera: true
                    },
                    default: false
                },
                {
                    name: 'planta03',
                    frame: 3,
                    uri: null,
                    type: null,
                    active: {
                        differential: true,
                        pin: true,
                        camera: true
                    },
                    default: false
                },
                {
                    name: 'planta04',
                    frame: 4,
                    uri: null,
                    type: null,
                    active: {
                        differential: true,
                        pin: true,
                        camera: true
                    },
                    default: false
                },
                {
                    name: 'planta05',
                    frame: 5,
                    uri: null,
                    type: null,
                    active: {
                        differential: true,
                        pin: true,
                        camera: true
                    },
                    default: false
                },
                {
                    name: 'planta06',
                    frame: 6,
                    uri: null,
                    type: null,
                    active: {
                        differential: true,
                        pin: true,
                        camera: true
                    },
                    default: false
                },
                {
                    name: 'planta07',
                    frame: 7,
                    uri: null,
                    type: null,
                    active: {
                        differential: true,
                        pin: true,
                        camera: true
                    },
                    default: false
                }
            ]
        },
        {
            name: 'vistas',
            frame: 11,
            uri: null,
            type: null,
            logo: 'large',
            dynamic: true,
            default: false
        },
        {
            name: 'historia',
            frame: 12,
            uri: null,
            type: null,
            logo: 'large',
            dynamic: true,
            default: false
        },
        // {
        //     name: 'video',
        //     frame: 13,
        //     uri: 'http://mona-web.local/public/media/mona.mp4',
        //     type: 'video',
        //     logo: 'large',
        //     dynamic: true,
        //     default: false
        // }
    ]
};

/**
 *
 * @type {{}}
 */
module.exports.game = {
    /**
     * Pseudos buttons.
     */
    pseudos: ['unvisited', 'hover', 'active']
};

/**
 *
 * @type {{}}
 */
module.exports.memory = {
    /**
     * Pseudos buttons.
     */
    pseudos: ['effect', 'unvisited', 'hover', 'active']
};

/**
 *
 * @type {{}}
 */
module.exports.default = {
    name: 'AllTap',
    description: 'App Interactive',
    app_name: 'VILA EMA',
    domain: 'http://vila-ema-web.local',
    timezone: 'America/Sao_Paulo',
    locale: 'pt',
    delay: 100,
    api: {
        ajax_setup_headers: {
            'Authorization': 'Bearer 10|XQ9Fp64YNrPE1I73zEpGdxjy1ZaZHXL6a895fRoZ'
        },
        url: 'http://gerenciador.local/api'
    },
    audio: {
        loop: true,
        all: true
    },
    video: {
        current_time: 0,
        thumbnail_time: 5
    },
    text: {
        font: 'MontserratRegular',
        weight: 'normal'
    },
    button: {
        color_icon: '0xFFFFFF'
    },
    fullscreen: {
        /**
         * fullscreen or audio
         */
        type: 'fullscreen',
        size: {
            width: 300,
            height: 'auto'
        },
        logo: 'icons/favicon-white.png',
        confirm: {
            disabled: false,
            text: 'Visualizar em tela cheia',
            // text: 'Ativar áudio',
            class: 'btn-default'
        },
        cancel: {
            disabled: false,
            text: 'Não, obrigado',
            class: 'btn-default'
        },
        /**
         * https://github.com/craftpip/jquery-confirm
         */
        options: {
            content: false,
            theme: 'supervan',
            closeIcon: false,
            animation: 'scale',
            draggable: false
        }
    },
    iframe: {
        size: {
            width: 1920,
            height: 1000,
        },
        attributes: {
            allowfullscreen: '0',
            scrolling: 'no',
            frameborder: '0'
        }
    },
    external: {
        size: {
            width: 800,
            height: 600
        },
        attributes: {
            toolbar: '0',
            location: '0',
            menubar: '0'
        }
    },
    gallery: {
        xml: 'gallery.xml',
        /**
         * https://github.com/Splidejs/splide
         */
        options: {
            type: 'loop',
            focus: 'center',
            pagination: false,
            perPage: 1,
            arrows: false,
            // legal_warn: 'perspectiva ilustrada'
            // autoplay: true
        }
    },
    implantation: {
        xml: 'implantation.xml',
        pin: {
            number_x: null,
            number_y: -7.2,
            color_enabled: '0x000000',
            color_disabled: '0xCCCCCC',
            color_round: '0xCCCCCC'
        },
        text: {
            text_x: 140,
            text_y: 34,
            color_number: '0xFFFFFF',
            color_text: '0x000000',
            font_size: 14,
            capitalize: true,
            upper_case: true
        },
        modal: {
            scale: 0.7,
            composition_name: 'capa',
            padding_vertical: 7,
            padding_horizontal: 20,
            color_text: '0xFFFFFF',
            color_symbol: '0x720F11'
        },
        content_text: {
            frame_01: {
                A: 5,
                B: 21,
                C: 34
            }
        }
    },
    scroll: {
        xml: 'scroll.xml',
        friction: 0.8,
        pin: {
            number_x: null,
            number_y: -7.2,
            color_enabled: '0x000000',
            color_disabled: '0xCCCCCC',
            color_round: '0xFFFFFF'
        },
        text: {
            text_x: 140,
            text_y: 34,
            color_number: '0xFFFFFF',
            color_text: '0xFFFFFF',
            font_size: 16,
            capitalize: false
        },
        modal: {
            scale: 0.7,
            composition_name: 'capa'
        },
        content_text: {
            frame_01: {
                A: 13
            }
        }
    },
    select: {
        friction: 0.8,
        text: {
            text_x: 140,
            text_y: 45,
            color_enabled: '0x333333',
            color_disabled: '0xAABBC0',
            font_size: 25,
            capitalize: false
        }
    },
    orientation: {
        speed: 2,
        slide: {
            color_title: '0x153D37',
            color_line: '0x153D37',
            color_arrow: '0x153D37',
            color_round: '0x153D37',
            color_circle: '0xAA6B41'
        },
        hours: {
            start: 6,
            end: 18
        },
        stations: [
            {
                month: 1,
                day: null
            },
            {
                month: 2,
                day: null
            },
            {
                month: 3,
                day: 20
            },
            {
                month: 4,
                day: null
            },
            {
                month: 5,
                day: null
            },
            {
                month: 6,
                day: 20
            },
            {
                month: 7,
                day: null
            },
            {
                month: 8,
                day: null
            },
            {
                month: 9,
                day: 22
            },
            {
                month: 10,
                day: null
            },
            {
                month: 11,
                day: null
            },
            {
                month: 12,
                day: 21
            }
        ],
        degrees: {
            autumn: 5,
            winter: 11,
            spring: 5,
            summer: 0
        }
    },
    _360: {
        speed: 6,
        slide: {
            color_title: '0xFFFFFF',
            color_line: '0xFFFFFF',
            color_arrow: '0xFFFFFF',
            color_round: '0xFFFFFF',
            color_circle: '0x000000'
        }
    },
    view: {
        xml: 'view.xml',
        frame: 1,
        pav: 1,
        text: {
            color_text: '0xFFFFFF',
            font_size: 18,
            text_x: null,
            text_y: 5
        },
    },
    routes: {
        web: {
            public_path: 'public',
            uri_css: 'public/css',
            uri_js: 'public/js',
            uri_images: 'public/images',
            uri_images_animate: 'public/images/animate',
            uri_xml: 'public/xml',
            uri_src: 'src',
            uri_cover: 'capa/capa'
        }
    },
    init: {
        fullscreen: false,
        before: false,
        /**
         * Single, compiler --min-resources=all
         */
        single: false,
        gallery: false,
        frame: 1,
        marker: true
    }
};

/**
 *
 * @param responsive_active Allow replies, 'true' or 'false'.
 * @param responsive_replies Replies by, 'width', 'height' or 'both'.
 * @param scale_active Scale to fill visible area, 'true' or 'false'.
 * @param scale_type Adjust in display 'center' or stretch to fit 'stretch', "1 or 2".
 * @param dom_containers Array containers resize, 'elements'.
 */
module.exports.make = {
    responsive_active: true,
    responsive_replies: 'both',
    scale_active: false,
    scale_type: 1
};
